import { Response } from '@marketplace-web/shared/api-client'

import { TrackingJourneySummaryResponse } from 'types/api/response/tracking-journey-summary-response'

import { transformTrackingJourneySummary } from 'data/transformers/tracking-journey-summary'

export const transformTrackingJourneySummaryResponse = (
  response: Response<TrackingJourneySummaryResponse>,
) => transformTrackingJourneySummary(response.journey_summary)
